import { NotificationDataSummary } from 'src/stores/notifications-store';
import { create } from 'zustand';

export type SessionNotifications = {
  readNotifications: { items: NotificationDataSummary[]; count: number };
  unreadNotifications: { items: NotificationDataSummary[]; count: number };
};

type SessionNotificationsStoreType = {
  state: SessionNotifications;
  setState: (newState: SessionNotifications) => void;
  setUnreadNotificationsCount: (count: number) => void;
  setUnreadNotifications: (notifications: NotificationDataSummary[], count: number) => void;
  setReadNotifications: (notifications: NotificationDataSummary[], count: number) => void;
  addUnreadNotification: (notif: NotificationDataSummary) => void;
  deleteUnreadNotification: (notif: NotificationDataSummary) => void;
  readAll: () => void;
};

export const useSessionNotifications = create<SessionNotificationsStoreType>((set, get) => ({
  state: { readNotifications: { items: [], count: 0 }, unreadNotifications: { items: [], count: 0 } },
  setState(newState) {
    set((prev) => ({
      ...prev,
      state: newState,
    }));
  },
  setUnreadNotificationsCount(count) {
    set((prev) => ({
      ...prev,
      state: { ...prev.state, unreadNotifications: { ...prev.state.unreadNotifications, count } },
    }));
  },
  setReadNotifications(notifications, count) {
    set((prev) => ({
      ...prev,
      state: { ...prev.state, readNotifications: { items: notifications, count } },
    }));
  },
  deleteUnreadNotification(notif) {
    set((prev) => ({
      ...prev,
      state: {
        ...prev.state,
        unreadNotifications: {
          items: prev.state.unreadNotifications.items.filter((v) => v.id !== notif.id),
          count: prev.state.unreadNotifications.count - 1,
        },
      },
    }));
  },
  setUnreadNotifications(notifications, count) {
    set((prev) => ({
      ...prev,
      state: { ...prev.state, unreadNotifications: { items: notifications, count } },
    }));
  },
  addUnreadNotification(notif) {
    set((prev) => ({
      ...prev,
      state: {
        ...prev.state,
        unreadNotifications: { items: [notif, ...prev.state.unreadNotifications.items], count: prev.state.unreadNotifications.count + 1 },
      },
    }));
  },
  readAll() {
    set((prev) => ({
      ...prev,
      state: {
        unreadNotifications: { items: [], count: 0 },
        readNotifications: {
          items: [],
          count: 0,
        },
      },
    }));
  },
}));
